import { lazy as loadLazy } from 'react'

/**
 * Shortcut for React.lazy as a drop-in replacement for React Router's lazy prop,
 * since that seems to be broken in the current version of React Router.
 */
export const lazy = (callback: () => Promise<{ Component: React.ComponentType }>) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
  return loadLazy(() => callback().then((module) => ({ default: module.Component })))
}
